module.exports = __webpack_public_path__ + "img/madera013.bf21e184.jpg";